import React from 'react'
import {PurchaseFormBlock} from '.'
import {ButtonBase} from '../Button/ButtonBase'
import {BlockComponentProps} from '../index'

interface BackButtonButtonProps extends PurchaseFormBlock, BlockComponentProps {
  disabled?: boolean
  onClick: () => void
}

export default function BackButtonButton(props: BackButtonButtonProps) {
  const {onClick, disabled, ...config} = props

  const buttonClassName = `back-button-${config.id}`

  const customStyles = {
    ...config.buttonStyle,
    height: '100%',
    minHeight: config.buttonStyle.height,
  }

  return (
    <>
      <style>
        {`
        .${buttonClassName} {
          min-width: 70px;
        }

        .${buttonClassName}:hover {
          border-color: ${config.buttonStyle.hoverBorderColor};
          background: ${config.buttonStyle.hoverBackgroundColor};
          border: ${config.buttonStyle.hoverBorderColor};
          color: ${config.buttonStyle.hoverTextColor};
        }

        .${buttonClassName}:hover div i {
          color: ${config.buttonStyle.hoverTextColor};
        }
        `}
      </style>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <ButtonBase
          {...customStyles}
          disabled={disabled}
          onClick={onClick}
          type="button"
          id={buttonClassName}
          className={buttonClassName}
        >
          <i
            className="fa-light fa-circle-arrow-left"
            title="Back to previous step"
          />
        </ButtonBase>
      </div>
    </>
  )
}
